import type { LatLng } from 'shared/lib/tracking/geo';

const DEFAULT_ORIGIN = {
  lat: 63.08239134476709,
  lng: 21.688833657412054,
};

function parseOrigin(): LatLng {
  const lat = parseFloat(
    import.meta.env.VITE_MOCK_TRACKING_SSE_ORIGIN_LAT ??
      String(DEFAULT_ORIGIN.lat),
  );
  const lng = parseFloat(
    import.meta.env.VITE_MOCK_TRACKING_SSE_ORIGIN_LNG ??
      String(DEFAULT_ORIGIN.lng),
  );
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return DEFAULT_ORIGIN;
  return { lat, lng };
}

/** Small steps (~80–120 m) forming a loop so the marker keeps moving while you stay still. */
function generateLoopRoute(origin: LatLng, points = 20): LatLng[] {
  const dLat = 0.0007;
  const dLng = 0.0011;
  const path: LatLng[] = [{ ...origin }];
  for (let i = 1; i < points; i++) {
    const t = i / points;
    const phase = (t * Math.PI * 2);
    path.push({
      lat: origin.lat + Math.sin(phase) * dLat,
      lng: origin.lng + Math.cos(phase) * dLng,
    });
  }
  return path;
}

/** Optional JSON: [{"lat":63.08,"lng":21.68}, ...] — used with VITE_MOCK_TRACKING_SSE=1 */
export function getMockTrackingSseRoute(): LatLng[] {
  const raw = import.meta.env.VITE_MOCK_TRACKING_SSE_ROUTE?.trim();
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as unknown;
      if (Array.isArray(parsed) && parsed.length >= 2) {
        const route = parsed
          .map((p) => {
            const row = p as { lat?: number; lng?: number };
            if (
              typeof row.lat === 'number' &&
              typeof row.lng === 'number' &&
              Number.isFinite(row.lat) &&
              Number.isFinite(row.lng)
            ) {
              return { lat: row.lat, lng: row.lng };
            }
            return null;
          })
          .filter((p): p is LatLng => p != null);
        if (route.length >= 2) return route;
      }
    } catch {
      console.warn(
        '[mockTrackingSseRoute] Invalid VITE_MOCK_TRACKING_SSE_ROUTE JSON; using generated loop.',
      );
    }
  }
  return generateLoopRoute(parseOrigin());
}
